import React from "react";
import LogoLight2x from "../../images/logo.png";
import LogoDark2x from "../../images/logo.png";
import LogoSmall from "../../images/logo.png";
import QuaereLogo from "../../images/logo.png"
import {Link} from "react-router-dom";

const Logo = () => {
  return (
    <Link to={`${process.env.PUBLIC_URL}/dashboard`} className="logo-link">
      <img className="logo-light logo-img" src={LogoLight2x} alt="logo" />
      <img  style={{width:"150px",height:"150px"}}className="logo-dark logo-img" src={QuaereLogo} alt="logo" />
      <img  style={{width:"150px",height:"150px"}} width={1000}className="logo-small logo-img logo-img-small" src={QuaereLogo} alt="logo" />
    </Link>
  );
};

export default Logo;
  